import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { InputSwitchModule } from 'primeng/inputswitch';
import { ServiceProviderImportPreviewComponent } from './service-provider-import-preview.component';

@NgModule({
  declarations: [ServiceProviderImportPreviewComponent],
  imports: [CommonModule, FormsModule, ButtonModule, RippleModule, InputSwitchModule],
  exports: [ServiceProviderImportPreviewComponent],
})
export class ServiceProviderImportPreviewModule {}
